var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookClosed = function SvgBookClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M11.667 11.083v-1.75H4.083a1.75 1.75 0 0 0-1.75 1.75m2.8 1.75H9.8c.653 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23V3.034c0-.653 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.126-.577-.126-1.23-.126H5.133c-.98 0-1.47 0-1.844.19a1.75 1.75 0 0 0-.765.765c-.19.375-.19.865-.19 1.845v6.066c0 .98 0 1.47.19 1.845.168.33.436.597.765.765.374.19.864.19 1.844.19"
  })));
};
export default SvgBookClosed;